import React, { FC } from 'react';
import styled from 'styled-components';

const _dumpsterSolid: FC<{ className?: string; fillColor?: string }> = ({ className, fillColor }) => (
    <svg width='52' height='52' viewBox='0 0 52 52' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M8.125 9.74609L4.875 22.7461H7.04272L7.58228 25.9961H4.875V29.2461H8.125L9.75 38.9961V42.2461H13V38.9961H39V42.2461H42.25V38.9961L43.875 29.2461H47.125V25.9961H44.4177L44.9573 22.7461H47.125L43.875 9.74609H27.625H24.375H8.125ZM10.6641 12.9961H15.1741L13.9299 19.4961H9.03906L10.6641 12.9961ZM18.5098 12.9961H24.375V19.4961H17.2751L18.5098 12.9961ZM27.625 12.9961H33.4902L34.7249 19.4961H27.625V12.9961ZM36.8259 12.9961H41.3359L42.9609 19.4961H38.0701L36.8259 12.9961ZM10.3372 22.7461H13.3079H16.6562H24.375H27.625H35.3438H38.6921H41.6628L39.4983 35.7461H12.5017L10.3372 22.7461Z'
            fill='white'
        />
    </svg>
);

const DumpsterSolid = styled(_dumpsterSolid)``;
export default DumpsterSolid;
